import { Directive, ElementRef, Renderer2 } from '@angular/core';

/**
 * This directive removes the paginator control from twc component. We don't need it
 */
@Directive({
    selector: '[cwHidePaginatorControl]',
    standalone: false,
})
export class HidePaginatorControlDirective {
    constructor(
        private el: ElementRef,
        private rendered: Renderer2
    ) {
        setTimeout(() => {
            if (!this.el.nativeElement.classList.contains('twc-paginator')) {
                return;
            }

            const paginatorControls = this.el.nativeElement.children.item('twc-paginator-controls');

            if (paginatorControls) {
                this.rendered.setStyle(paginatorControls, 'visibility', 'hidden');
            }
        });
    }
}
